import { h } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import { send, exitToSchneiderEvent, isAnalyticsEnabled, scrollToComponent, store, setLinearProductData, ACTION_TYPES, tryParse, ETabType } from '@pes-ui/utils';
import { isMobile } from '../../../globals/utils';
import { observeIntersectionWithHeader, setStickyBarTab, setTabActive, } from '../../../globals/stickyBar.utils';
export class Faq {
  constructor() {
    this.handleClick = (e) => {
      var _a;
      if (this.type === 'community' && isAnalyticsEnabled()) {
        send(exitToSchneiderEvent, {
          link_url: encodeURI(this.getUrlTempltae().replace('#rangenamesearchterm#', this.rangeName)),
        });
      }
      (_a = this.didClickFAQLink) === null || _a === void 0 ? void 0 : _a.emit({ nativeEvent: e });
    };
    this.getStyles = () => {
      const imageUrl = this.isMobile ? this.mobileImageUrl : this.desktopImageUrl;
      return {
        'background-image': `url(${imageUrl})`,
      };
    };
    this.getUrlTempltae = () => {
      return this.type !== undefined ? this.urlTemplate : this.faqUrl;
    };
    this.resizeWindow = () => {
      this.isMobile = isMobile();
    };
    this.desktopImageUrl = undefined;
    this.mobileImageUrl = undefined;
    this.faqUrl = undefined;
    this.labels = undefined;
    this.rangeName = undefined;
    this.commercialReference = undefined;
    this.type = undefined;
    this.urlTemplate = undefined;
    this._desktopImageUrl = undefined;
    this._mobileImageUrl = undefined;
    this._faqUrl = undefined;
    this._labels = undefined;
    this._rangeName = undefined;
    this._commercialReference = undefined;
    this.isMobile = isMobile();
  }
  handleTabClicked(event) {
    if (this.el && event.detail.type === ETabType.FAQ) {
      scrollToComponent(this.el);
    }
  }
  observe() {
    if (this.el) {
      observeIntersectionWithHeader(this.el, (entries) => {
        var _a, _b, _c;
        if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
          setTabActive({ type: ETabType.FAQ, title: ((_b = this.labels) === null || _b === void 0 ? void 0 : _b.shortText) || ((_c = this.labels) === null || _c === void 0 ? void 0 : _c.text) });
          this.setTabActive.emit();
        }
      });
    }
  }
  initializeStickyBarTab() {
    var _a;
    setStickyBarTab(ETabType.FAQ, [(_a = this.labels) === null || _a === void 0 ? void 0 : _a.shortText]);
    this.observe();
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f;
    this.desktopImageUrl = (_a = tryParse(this._desktopImageUrl)) !== null && _a !== void 0 ? _a : this.desktopImageUrl;
    this.mobileImageUrl = (_b = tryParse(this._mobileImageUrl)) !== null && _b !== void 0 ? _b : this.mobileImageUrl;
    this.faqUrl = (_c = tryParse(this._faqUrl)) !== null && _c !== void 0 ? _c : this.faqUrl;
    this.labels = (_d = tryParse(this._labels)) !== null && _d !== void 0 ? _d : this.labels;
    this.rangeName = (_e = tryParse(this._rangeName)) !== null && _e !== void 0 ? _e : this.rangeName;
    this.commercialReference = (_f = tryParse(this._commercialReference)) !== null && _f !== void 0 ? _f : this.commercialReference;
    store.dispatch(setLinearProductData({ faq: {
        desktopImageUrl: this.desktopImageUrl,
        mobileImageUrl: this.mobileImageUrl,
        faqUrl: this.faqUrl,
        labels: this.labels,
        rangeName: this.rangeName,
        commercialReference: this.commercialReference,
      } }));
    this.unsubscribe = store.subscribe(() => {
      var _a;
      const { data, activeProductTab, lastActionType } = store.getState().product;
      if (lastActionType !== ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB)
        return;
      if (!((_a = data[activeProductTab]) === null || _a === void 0 ? void 0 : _a.faq))
        return;
      const { desktopImageUrl, mobileImageUrl, faqUrl, labels, rangeName, commercialReference, } = data[activeProductTab].faq;
      this.desktopImageUrl = desktopImageUrl;
      this.mobileImageUrl = mobileImageUrl;
      this.faqUrl = faqUrl;
      this.labels = labels;
      this.rangeName = rangeName;
      this.commercialReference = commercialReference;
      this.initializeStickyBarTab();
    });
  }
  componentDidLoad() {
    var _a;
    if ((_a = this.labels) === null || _a === void 0 ? void 0 : _a.shortText) {
      this.initializeStickyBarTab();
    }
  }
  connectedCallback() {
    window.addEventListener('resize', this.resizeWindow);
  }
  disconnectedCallback() {
    var _a;
    window.removeEventListener('resize', this.resizeWindow);
    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    if (isEmpty(this.labels) && !this.rangeName && !this.commercialReference) {
      return null;
    }
    const urlTemplate = this.getUrlTempltae();
    const url = this.type !== undefined && this.type === 'community'
      ? encodeURI(urlTemplate.replace('#rangenamesearchterm#', this.rangeName))
      : encodeURI(urlTemplate.replace('#searchterm#', `${this.rangeName} ${this.commercialReference}`));
    return (h("section", { class: "faq", style: this.getStyles() }, h("h2", { class: "faq__heading" }, this.labels.heading), h("p", { class: "faq__text" }, this.labels.text), h("div", { class: "faq__button-wrapper" }, h("qds-button", { size: "large", importance: "emphasized", href: url, target: "_blank", class: "faq__button-link", text: this.labels.button, onClick: this.handleClick }))));
  }
  static get is() { return "pes-faq"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["faq.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["faq.css"]
    };
  }
  static get properties() {
    return {
      "desktopImageUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Background image URL for desktop"
        },
        "attribute": "desktop-image-url",
        "reflect": false
      },
      "mobileImageUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Background image URL for mobile"
        },
        "attribute": "mobile-image-url",
        "reflect": false
      },
      "faqUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "http://www.se.com/en/faqs/index?page=answers&question_box=#searchterm#"
            }],
          "text": "URL for redirecting to FAQ page. Link should contain #searchterm# placeholder.\n\n#searchterm# placeholder will be replaced with range name and commercial reference."
        },
        "attribute": "faq-url",
        "reflect": false
      },
      "labels": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TFAQLabels",
          "resolved": "{ text: string; button: string; heading: string; shortText?: string; }",
          "references": {
            "TFAQLabels": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Labels for text, button and heading."
        }
      },
      "rangeName": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "Harmony"
            }],
          "text": "Range name"
        },
        "attribute": "range-name",
        "reflect": false
      },
      "commercialReference": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "XVD"
            }],
          "text": "Commercial reference"
        },
        "attribute": "commercial-reference",
        "reflect": false
      },
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TFAQTypes",
          "resolved": "\"community\" | \"faq\"",
          "references": {
            "TFAQTypes": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "community"
            }],
          "text": "Banner type, community or faq"
        },
        "attribute": "type",
        "reflect": false
      },
      "urlTemplate": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "url-template",
        "reflect": false
      },
      "_desktopImageUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-desktop-image-url",
        "reflect": false
      },
      "_mobileImageUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-mobile-image-url",
        "reflect": false
      },
      "_faqUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-faq-url",
        "reflect": false
      },
      "_labels": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-labels",
        "reflect": false
      },
      "_rangeName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-name",
        "reflect": false
      },
      "_commercialReference": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-commercial-reference",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "isMobile": {}
    };
  }
  static get events() {
    return [{
        "method": "didClickFAQLink",
        "name": "didClickFAQLink",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Passes native event data on a link click."
        },
        "complexType": {
          "original": "{ nativeEvent: MouseEvent }",
          "resolved": "{ nativeEvent: MouseEvent; }",
          "references": {
            "MouseEvent": {
              "location": "global"
            }
          }
        }
      }, {
        "method": "setTabActive",
        "name": "setTabActive",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "tabClicked",
        "method": "handleTabClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
